import { render, staticRenderFns } from "./riwayat.vue?vue&type=template&id=7fcb175d&"
import script from "./riwayat.vue?vue&type=script&lang=js&"
export * from "./riwayat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports